module.exports = __webpack_public_path__ + "img/category-favorite-hover.f8ab454f.png";